import {
  ICommonCurriculums,
  ICommonKeywords, ICommonGrades, ICommonSubjects, ICommonTutorialTypes,
} from '@/store/types';
import { createSliceSteamup } from '../common';

interface IConstantsState {
  keywords: ICommonKeywords;
  curriculums: ICommonCurriculums[];
  grades: ICommonGrades[];
  subjects: ICommonSubjects[];
  tutorialTypes: ICommonTutorialTypes[];
}

const constantsSlice = createSliceSteamup(
  'constants',
  {
    keywords: {},
    curriculums: [],
    grades: [],
    subjects: [],
    tutorialTypes: [],
  } as IConstantsState,
);

export default constantsSlice;
